import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { replaceLink } from 'shared/lib'
import {
  type IShortLinkMergeFieldAction,
  type IShortLinkUrlEditorFactory,
} from 'entities/ShortLink/api/types'
import { ShortenLinkIconAction } from 'entities/ShortLink'
import { useMessageFieldContext } from 'widgets/MessageField/context/MessageFieldContext'

type IShortenLinkActionProps = {
  mergeFieldAction?: IShortLinkMergeFieldAction | null
  urlEditorFactory?: IShortLinkUrlEditorFactory | null
}

export const ShortenLinkAction: FC<IShortenLinkActionProps> = observer(
  ({ mergeFieldAction, urlEditorFactory }) => {
    const messageFieldStore = useMessageFieldContext()

    return (
      <ShortenLinkIconAction
        onAddShortLink={(link: string) =>
          messageFieldStore.addContent && messageFieldStore.addContent(replaceLink(link) + '&nbsp;')
        }
        iconButtonProps={messageFieldStore.iconButtonProps}
        mergeFieldAction={mergeFieldAction}
        urlEditorFactory={urlEditorFactory}
      />
    )
  }
)
